import React, {Component} from 'react';
import 'react-select/dist/react-select.css';
import Select from 'react-select';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';

class DAWAAddress extends React.Component {
    constructor(props) {
        super(props);
        this.onInputChange = this.onInputChange.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    onInputChange(text) {
        if (this.checkParams(text, this.props)) {
            this.props.onSearch(this.formatSearchParams(text, this.props));
        }
    }

    checkParams(text, props) {
        return props.regionId !== '' &&
            props.municipalityId !== '' &&
            text !== ''
    }

    formatSearchParams(text, props) {
        return {
            searchString: text,
            municipalityId: props.municipalityId,
            regionId: props.regionId,
            id: props.addressId
        }
    }


    onChange(id) {
        if (this.props.input.onChange && id !== null) {
            this.props.input.onChange(id);
            this.props.onSelect(id);
            this.props.onDetails(id);
        } else {
            this.props.input.onChange(null);
            this.props.onClear(this.props.resourceType);
        }
    }

    render() {
        return (
            <Select
                {...this.props}
                value={this.props.input.value}
                options={this.props.addresses}
                onInputChange={this.onInputChange}
                onChange={this.onChange}
                simpleValue={true}
                clearable={false}
                placeholder={this.props.intl.formatMessage(messages.select)}
                onBlur={() => this.props.input.onBlur(this.props.input.value)}
            />
        );
    }
}


export default injectIntl(DAWAAddress);




// WEBPACK FOOTER //
// ./web/src/components/users/DAWAAddress.jsx